import { takeLatest, put } from 'redux-saga/effects';

import { SnackbarsTypes } from './types';
import * as SnackbarsActions from './actions';

// Sagas
function* setOpen({ payload }: any) {
  try {
    yield put(SnackbarsActions.setOpen({ ...payload }));
  } catch (err) {
    console.error('snackbars - snackbarOpen - err', err);
  }
}

function* setClose() {
  try {
    yield put(SnackbarsActions.setClose());
  } catch (err) {
    console.error('snackbars - snackbarClose - err', err);
  }
}

export const snackbarsSagas = [
  takeLatest(
    (ac: { type?: any }) =>
      ac.type === SnackbarsTypes.SET_OPEN && Object.keys(ac).length === 1,
    setOpen,
  ),
  takeLatest(
    (ac: { type?: any }) =>
      ac.type === SnackbarsTypes.SET_CLOSE && Object.keys(ac).length === 1,
    setClose,
  ),
];
